export default "__VITE_ASSET__CCC9glq6__"